<template>
  <div>
    <page-header title="Incident And Request" breadcrumb="Dashboard > Booking & Shipments > Incident And Request" />
    <div class="bg-white p-3">
      <div class="flex justify-between flex-wrap">
        <div class="flex gap-4 p-3 w-full lg:w-6/12">
          <qrcode />
          <div class="flex flex-col">
            <p><span class="font-bold">Truck breakdown</span> by <span class="font-bold">James Obinna</span></p>
            <p>created <span class="opacity-50">{{ formatTime(request.createdAt) }}</span></p>
            <p>Status: <span class="text-green">{{ request.status || "" }}</span></p>
            <p>Shipping Ref: {{ request.shippingDispatchRef || "" }}</p>
          </div>
        </div>
        <div class="flex flex-col p-3 w-full lg:w-6/12" style="background: #F9FAFC;">
          <p><span class="inline-block w-40">Request Category:</span> <span>{{ request.requestCategory || "" }}</span>
          </p>
          <p><span class="inline-block w-40">Severity:</span> <span>{{ request.severity || "" }}</span></p>
          <p><span class="inline-block w-40">Address:</span> <span>{{ request.address || "N/A" }}</span></p>
        </div>
      </div>
      <hr class="my-8">
      <h3 class="font-bold text-lg">Incident Detail</h3>
      <p class="my-7 opacity-75 white-space-pre-line">
        {{ request.requestDetail || "" }}
      </p>
      <hr>
      <h3 class="font-bold text-lg my-8">Attachments</h3>
      <div class="flex justify-between items-center flex-wrap" style="background: #F9FAFC;">
        <div class="flex gap-2 p-2">
          <div class="image_content" v-for="value in request.attachments || []" :key="value">
            <img src="@/assets/images/icons/image-placeholder.svg" alt="Attach Image">
            image_1
          </div>
        </div>
        <div class="flex gap-2 pt-3 pr-3" v-if="(request.attachments || []).length > 0">
          <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.87695 10.4102C7.89157 10.4288 7.91024 10.4439 7.93156 10.4543C7.95288 10.4647 7.97629 10.4701 8 10.4701C8.02371 10.4701 8.04712 10.4647 8.06844 10.4543C8.08976 10.4439 8.10843 10.4288 8.12305 10.4102L10.3105 7.64258C10.3906 7.54102 10.3184 7.39062 10.1875 7.39062H8.74023V0.78125C8.74023 0.695312 8.66992 0.625 8.58398 0.625H7.41211C7.32617 0.625 7.25586 0.695312 7.25586 0.78125V7.38867H5.8125C5.68164 7.38867 5.60938 7.53906 5.68945 7.64062L7.87695 10.4102ZM15.1484 9.72656H13.9766C13.8906 9.72656 13.8203 9.79688 13.8203 9.88281V12.8906H2.17969V9.88281C2.17969 9.79688 2.10938 9.72656 2.02344 9.72656H0.851562C0.765625 9.72656 0.695312 9.79688 0.695312 9.88281V13.75C0.695312 14.0957 0.974609 14.375 1.32031 14.375H14.6797C15.0254 14.375 15.3047 14.0957 15.3047 13.75V9.88281C15.3047 9.79688 15.2344 9.72656 15.1484 9.72656Z"
              fill="#1831CC" />
          </svg>

          Download all attachments
        </div>
      </div>
      <hr class="my-8">
      <h3 class="font-bold">Comments</h3>
      <p class="my-4">Write a Comment</p>
      <textarea class="my-2 p-4 resize-none w-full" name="" id="" cols="30" rows="10" style="background: #F9FAFC;"
        placeholder="Thanks  James Obinna. We will provide a vehicle close by as soon as possible."></textarea>
      <div class="flex justify-end mb-6">
        <div class="float_right mr-2">
          <base-button text="Send" />
        </div>
      </div>
      <div class="flex justify-between my-4 items-start">
        <div class="flex flex-col w-full">
          <div class="flex gap-2 items-start">
            <img src="@/assets/images/icons/person_logo.svg" />
            <div class="flex flex-wrap justify-between w-full">
              <div class="mt-2">
                <span class="font-bold">Jane adekole </span>
                <span class="text-gray-400 text-sm">12/02/2021, Added 20 minutes ago.</span>
              </div>
              <div class="flex gap-3 items-center mt-2">
                <div class="flex gap-2 text-sm cursor-pointer">
                  <img class="w-5" src="@/assets/images/icons/reply-icon.svg" alt="Attach Image" />
                  <span class="">Reply</span>
                </div>
                <div class="flex gap-2 text-sm cursor-pointer">
                  <img class="w-[1rem]" src="@/assets/images/icons/edit.svg" alt="Attach Image" />
                  <span class="">Edit</span>
                </div>
              </div>

              <p class="w-full mt-2 text-sm">Driver dispatched. ETA: 2 Hours.</p>
              <textarea class="my-2 p-4 resize-none w-full text-sm hidden" style="background: #F9FAFC;"
                placeholder="Thanks  James Obinna. We will provide a vehicle close by as soon as possible."></textarea>
              <button class="text-sm text-primary-yellow font-semibold hidden">Update Comment</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import moment from "moment";

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      request: {}
    }
  },
  mounted() {
    this.getRequestById()
  },
  methods: {
    formatTime(date) {
      return moment(date).format("Do MMMM, YYYY")
    },
    async getRequestById() {
      try {
        const response = await this.$_requestById(this.$route.params.id);
        console.log(response?.data?.data?.assistanceRequest);
        this.request = response?.data?.data?.assistanceRequest;
      } catch (error) {
        //
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.float_right {
  @apply w-24
}

.image_content {
  @apply text-sm
}

.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #FCC210;
    font-weight: bold;
  }
}
</style>